
import ListComponent from "../../../components/operating_costs/Index.vue";

export default {
  components: {
    ListComponent
  }
}
